<script setup lang="ts">
import { computed } from 'vue'

const regionMenu = computed(() => {
    return window.regionMenu
})
</script>
<template>
    <!-- start region menu -->
    <div v-if="regionMenu" class="choose-region d-flex align-items-center my-1 flex-1 justify-start">
        <div class="d-none-md d-flex align-items-center dropdown dropdown-select flex-1">
            <div class="dropdown-title region-dropdown d-flex align-items-center text-primary">
                <span class="text-uppercase mr-1">{{ regionMenu.name }}</span>
            </div>

            <ul id="menu-regionen" class="dropdown-list region-list ml-0 list-none bg-white">
                <li
                    v-for="(link, index) in regionMenu.items"
                    :key="index"
                    class="menu-item menu-item-type-custom menu-item-object-custom select-item d-flex align-items-center justify-between">
                    <a :href="link.url">{{ link.title }}</a>
                </li>
            </ul>
        </div>
    </div>
    <!-- end region menu -->
</template>

<style scoped></style>
